import { NavLink } from "../../../../../types/drawer/NavItem";

export const nav_links: NavLink[] = [
  { href: "/", text: "Home", icon: "Home" },
  { href: "/desktop", text: "Desktop App", icon: "Monitor" },
  {
    text: "Solutions",
    icon: "Layers",
    href: "/solutions",
    children: [
      {
        category: "Automation Solutions",
        icon: "Settings",
        links: [
          {
            href: "/solutions/automation-services",
            text: "Automation Services",
            icon: "Workflow",
          },
          {
            href: "/solutions/robotic-automation",
            text: "Robotic Automation",
            icon: "Cpu",
          },
          {
            href: "/solutions/workflow-automation",
            text: "Workflow Automation",
            icon: "Repeat",
          },
        ],
      },
      {
        category: "Support and Expertise",
        icon: "LifeBuoy",
        links: [
          {
            href: "/solutions/outage-hub",
            text: "Outage Hub",
            icon: "AlertCircle",
          },
          {
            href: "/solutions/troubleshooting",
            text: "Troubleshooting",
            icon: "Wrench",
          },
        ],
      },
      {
        category: "Project and Knowledge",
        icon: "Book",
        links: [
          {
            href: "/solutions/project-execution",
            text: "Project Execution",
            icon: "ClipboardCheck",
          },
          {
            href: "/solutions/agnostic-knowledge",
            text: "Agnostic Knowledge",
            icon: "Brain",
          },
          {
            href: "/solutions/onboarding",
            text: "Onboarding",
            icon: "UserPlus",
          },
        ],
      },
    ],
  },
  { href: "/integrations", text: "Integrations", icon: "LinkIcon" },
  { href: "/reporting", text: "Reporting", icon: "LayoutDashboard" },
  { href: "/portal", text: "Portal", icon: "Globe" },
  { href: "/roadmap", text: "Roadmap", icon: "Map" },
  { href: "/sweepstakes", text: "Sweepstakes", icon: "Ticket" },
  { href: "/investments", text: "Investments", icon: "Banknote" },
  { href: "/feedback", text: "Feedback", icon: "MessageSquare" },
];
